import { render, staticRenderFns } from "./ModalKasKecilFilePreview.vue?vue&type=template&id=0745f2c2&scoped=true&"
import script from "./ModalKasKecilFilePreview.vue?vue&type=script&lang=js&"
export * from "./ModalKasKecilFilePreview.vue?vue&type=script&lang=js&"
import style0 from "./ModalKasKecilFilePreview.vue?vue&type=style&index=0&id=0745f2c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0745f2c2",
  null
  
)

export default component.exports